export default {
    _elements: null,
    init() {
        this._elements = document.querySelectorAll('.waiting');

        if (!this._elements) {
            return;
        }

        /* delay(10); */
        this.checkElements();
        
        document.addEventListener('scroll', () => {
            this.checkElements();
        });
    },
    checkElements() {
        this._elements = document.getElementsByClassName('waiting');
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        if (this._elements.length > 0) {
            for (let i=0; i < this._elements.length; i++) {
                let element = this._elements[i];

                if (this._inView(element, windowHeight)) {
                    //element.classList.remove('waiting'); //WILL CAUSE THE LOOP TO FREAK OUT
                    element.classList.add('visible');
                }
            }
        }
    },
    _inView(element, windowHeight) {
        const bounds = element.getBoundingClientRect();
        return bounds.top <= windowHeight-50;
    }
    
}